import { useTranslation } from "react-i18next";
import CustomSharedConfirmationModal from "sipli-fleet-core/components/CustomSharedConfirmationModal/CustomSharedConfirmationModal";

interface UnitModelsDeleteProps {
  open: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const UnitModelsDelete = ({
  open,
  isLoading,
  onCancel,
  onConfirm,
}: UnitModelsDeleteProps) => {
  const { t } = useTranslation();

  return (
    <CustomSharedConfirmationModal
      open={open}
      title={t("delete_unit_model")}
      description={t("delete_unit_model_confirmation")}
      confirmText={t("delete")}
      cancelText={t("cancel")}
      isLoading={isLoading}
      onCancel={onCancel}
      onConfirm={onConfirm}
      centered
    />
  );
};

export default UnitModelsDelete;
